import React, { useState } from 'react'
import { Button, ConfigProvider, Form, Modal, Radio, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { FormButton } from '../group.styled'
import { addBrandUser } from '../../../apis/brand'

function AddBrandToUserModal (props) {
  const { show, setShow, data = {}, successCallback = () => {}, brandOptions = [], adminMode } = props
  const { t: ln_t } = useTranslation()
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)
  const brandOpt = adminMode ? brandOptions?.filter(i => i.groupId === data?.id) : brandOptions
  const joinedBrand = data?.brands?.map(i => i.id) || []

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`user.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({ name, label: ln_t(`user.${name}`), rules: [{ required, message: defPlaceholder(name, type) }] })

  const handleClose = () => {
    setShow(false)
    form.resetFields()
  }

  const handleSave = async value => {
    setIsLoading(true)
    const userId = adminMode ? data?.userId : data?.id
    const res = await addBrandUser({ ...value, userId, role: 'member' })
    if (res?.status === 201) {
      successCallback(userId)
      handleClose()
    }
    setIsLoading(false)
  }

  return (
    <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
      <Modal title={`${ln_t('util.add')} ${data?.name} ${ln_t('util.to')} ${ln_t('user.brand')}`} open={show} onCancel={handleClose} footer={null}>
        <Form form={form} layout="vertical" requiredMark={false} onFinish={e => handleSave(e)}>
          <Form.Item {...defConfig('brand', 'select')} name="brandId" style={{ marginTop: '16px' }}>
            <Select
              showSearch
              placeholder={defPlaceholder('brand', 'select')}
              options={brandOpt?.map(i => ({ ...i, disabled: joinedBrand.includes(i.value) }))}
              optionFilterProp="children"
            />
          </Form.Item>
          {/* <Form.Item {...defConfig('role', 'select')}>
            <Select
              showSearch
              placeholder={defPlaceholder('role', 'select')}
              options={brandRoleOptions}
              optionFilterProp="children"
            />
          </Form.Item> */}
          <Form.Item {...defConfig('status', 'select')} initialValue={1}>
            <Radio.Group
              options={[{ value: 1, label: ln_t('util.enable') }, { value: 0, label: ln_t('util.disable') }]}
              optionType="button"
              buttonStyle="solid"
            />
          </Form.Item>
          <FormButton>
            <Button type="default" onClick={handleClose}>{ln_t('util.cancel')}</Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>{ln_t('util.confirm')}</Button>
          </FormButton>
        </Form>
      </Modal>
    </ConfigProvider>
  )
}

export default AddBrandToUserModal
